import './styles/main.css';
import { App } from './App';

const rootEl = document.getElementById('app');
if (rootEl) {
  const app = new App(rootEl);
  app.start();
}
